import React from 'react';
import {Trans} from 'react-i18next';
import {CONSTANTS} from '../../../../../../Shared/Constants/Constants';
import {IssueProfile} from '../../../SensorIssueForm/IssueAlarmFormState';

type IssueAlarmsLowBatteryWarningProps = {
	sensorIssuesForm: IssueProfile;
	show: boolean;
};

export default function IssueAlarmsLowBatteryWarningComponent(props: IssueAlarmsLowBatteryWarningProps) {
	return (
		props.show && (
			<tr>
				<td>
					<Trans i18nKey={'sensorWizard.summary.lowBatteryWarning'} />
				</td>
				<td>
					{(() => {
						if (props.sensorIssuesForm == null) {
							return CONSTANTS.NOT_AVAILABLE;
						}
						return props.sensorIssuesForm.low_battery_warning ? CONSTANTS.YES : CONSTANTS.NO;
					})()}
				</td>
			</tr>
		)
	);
}
